// extracted by mini-css-extract-plugin
export default {"actions":"actions_actions__tiY5r","popconfirmMessage":"actions_popconfirmMessage__xY9I9","moreIcon":"actions_moreIcon__Npb3S"};